import { render, staticRenderFns } from "./BandejaEmbajadorHallazgoV5.vue?vue&type=template&id=609c7b24&scoped=true"
import script from "./BandejaEmbajadorHallazgoV5.vue?vue&type=script&lang=js"
export * from "./BandejaEmbajadorHallazgoV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c7b24",
  null
  
)

export default component.exports